<template>
  <div class="container">
    <h1 id="EmailOutboxTitle">E-Mail Outbox</h1>
    <div class="row margin-bottom-2">
      <div class="col-xs-4">
        <DevAppDropDownComponent role="email" @devapp-changed="devAppChanged"/>
      </div>
    </div>
    <sdx-loading-spinner id="spinner-outbox" size="large" sr-hint="Loading. Please wait."
                         class="spinner-dashboard hidden"></sdx-loading-spinner>
    <div id="outbox" v-if="showOutbox">
      <div class="row margin-bottom-2" style="padding-left: 12px">
        <div class="filter-item" >
          <span class="filter-item-title">Recipient</span>
          <sdx-input
              placeholder="Recipient"
              :value="to"
              @input="recipientChange"
              class="filter-item"
          />
        </div>
        <div class="filter-item" >
          <span class="filter-item-title">CC (Carbon Copy)</span>
          <sdx-input
              placeholder="CC (Carbon Copy)"
              :value="cc"
              @input="ccChange"
              class="filter-item"
          />
        </div>
        <div class="filter-item" >
          <span class="filter-item-title">BCC (Blind Carbon Copy)</span>
          <sdx-input
              placeholder="BCC (Blind Carbon Copy)"
              :value="bcc"
              @input="bccChange"
              class="filter-item"
          />
        </div>
        <div class="filter-item">
          <span class="filter-item-title">Status</span>
          <sdx-select
              data-testid="statusDropDown"
              placeholder="Choose..."
              :value="responseStatus"
              @input="statusChange"
              class="filter-item"
          >
            <sdx-select-option
                v-for="(statusElem, idx) in statusList"
                :value="statusElem.value"
                :key="idx"
            >
              {{ statusElem.label }}
            </sdx-select-option>
          </sdx-select>
        </div>
        <div class="filter-item" style="width: 240px">
          <span class="filter-item-title">Sent Since</span>
          <sdx-menu-flyout>
            <sdx-menu-flyout-toggle>
              <sdx-icon icon-name="icon-information-circle" sr-hint="Read more"
                        data-testid="infoSentSince"></sdx-icon>
            </sdx-menu-flyout-toggle>
            <sdx-menu-flyout-content style="width: 600px;">
              <p>
                Email Outbox data exist only for 6 months back.
              </p>
            </sdx-menu-flyout-content>
          </sdx-menu-flyout>
          <sdx-input
              style="margin-top: 3px;"
              name="outboxFromDate"
              data-testid="sentSince"
              type="date"
              placeholder="01.01.2025 00:00:00"
              flatpickr-options='{"maxDate":"today", "dateFormat":"d.m.Y H:i:S", "locale":"de", "enableTime":"true", "enableSeconds":"true", "time_24hr":"true"}'
              :value="dateRange.fromDate"
              @input="fromDateChange"
          />
        </div>
        <div class="filter-item" style="width: 240px">
          <!-- https://flatpickr.js.org/options/ -->
          <span class="filter-item-title">Sent Until</span>
          <sdx-input
              style="margin-top: 3px;"
              name="outboxToDate"
              data-testid="sentUntil"
              type="date"
              placeholder="31.01.2025 23:59:59"
              flatpickr-options='{"maxDate":"today", "dateFormat":"d.m.Y H:i:S", "locale":"de", "enableTime":"true", "enableSeconds":"true", "time_24hr":"true", "defaultHour":"23", "defaultMinute":"59", "defaultSecond":"59"}'
              :value="dateRange.toDate"
              @input="toDateChange"
          />
        </div>
      </div>
      <sdx-loading-spinner id="spinner-outbox-content" size="large"
                           sr-hint="Loading. Please wait."></sdx-loading-spinner>

      <div id="outbox-content">
        <div id="email_outbox">
          <div class="email-outbox-table table table--responsive table--highlight margin-v-2">
            <div class="table_wrapper">
              <table data-init="auto">
                <thead>
                <tr>
                  <th class="table-header">Recipient</th>
                  <th class="table-header">CC (Carbon Copy)</th>
                  <th class="table-header">BCC (Blind Carbon Copy)</th>
                  <th class="table-header">Status</th>
                  <th class="table-header">Response</th>
                  <th class="table-header">Backend Error</th>
                  <th class="table-header">Attachments</th>
                  <th class="table-header">Sent</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in statisticOutbox" :key="index" id="emailOutboxTr">
                  <td>
                    <template v-if="item.to && item.to.length > 1">
                      <sdx-dialog
                          display-change-callback="
      if (arguments[0] === 'open') document.querySelector('#first-input-element3').doFocus();
      if (arguments[0] === 'closing') document.querySelector('#closable-modal-opener3').doFocus()
    "
                          label="E-Mail Recipients"
                          type="closable-modal"
                          id="modal-to"

                      >
                        <sdx-dialog-toggle>
                          <div class="toolbar__item item--show padding-icon">
                            <button aria-label="Bin">
                              {{ item.to[0] }}; ...
                              <i class="Show" aria-hidden="true" title="Details"></i>
                              <span class="toolbar__label"></span>
                            </button>
                          </div>
                        </sdx-dialog-toggle>

                        <sdx-dialog-content class="col-md-3">
                          <ul class="email-list">
                            <li v-for="email in item.to" :key="email">{{ email }}</li>
                          </ul>
                        </sdx-dialog-content>
                      </sdx-dialog>
                    </template>
                    <template v-else-if="item.to && item.to.length === 1">
                      <span class="email-value">{{ item.to[0] }}</span>
                    </template>
                    <template v-else>
                      <span class="email-value">&nbsp;</span>
                    </template>
                  </td>
                  <td>
                    <template v-if="item.cc && item.cc.length > 1">
                      <sdx-dialog
                          display-change-callback="
      if (arguments[0] === 'open') document.querySelector('#first-input-element3').doFocus();
      if (arguments[0] === 'closing') document.querySelector('#closable-modal-opener3').doFocus()
    "
                          label="E-Mail Recipients:"
                          type="closable-modal"
                          id="modal-cc">
                        <sdx-dialog-toggle>
                          <div class="toolbar__item item--show padding-icon">
                            <button aria-label="Bin">
                              {{ item.cc[0] }}; ...
                              <i class="Show" aria-hidden="true" title="Details"></i>
                              <span class="toolbar__label"></span>
                            </button>
                          </div>
                        </sdx-dialog-toggle>

                        <sdx-dialog-content class="col-md-3">

                          <ul class="email-list">
                            <li v-for="email in item.cc" :key="email">{{ email }}</li>
                          </ul>
                        </sdx-dialog-content>
                      </sdx-dialog>
                    </template>
                    <template v-else-if="item.cc && item.cc.length === 1">
                      <span class="email-value">{{ item.cc[0] }}</span>
                    </template>
                    <template v-else>
                      <span class="email-value">&nbsp;</span>
                    </template>
                  </td>
                  <td>
                    <template v-if="item.bcc && item.bcc.length > 1">
                      <sdx-dialog
                          display-change-callback="
      if (arguments[0] === 'open') document.querySelector('#first-input-element3').doFocus();
      if (arguments[0] === 'closing') document.querySelector('#closable-modal-opener3').doFocus()
    "
                          label="E-Mail Recipients:"
                          type="closable-modal"
                          id="modal-cc"
                          icon-name="icon-email"
                          align-header-center
                      >
                        <sdx-dialog-toggle>
                          <div class="toolbar__item item--show padding-icon">
                            <button aria-label="Bin">
                              {{ item.bcc[0] }}; ...
                              <i class="Show" aria-hidden="true" title="Details"></i>
                              <span class="toolbar__label"></span>
                            </button>
                          </div>
                        </sdx-dialog-toggle>

                        <sdx-dialog-content class="col-md-3">
                          <ul class="email-list">
                            <li v-for="email in item.bcc" :key="email">{{ email }}</li>
                          </ul>
                        </sdx-dialog-content>
                      </sdx-dialog>
                    </template>
                    <template v-else-if="item.bcc && item.bcc.length === 1">
                      <span class="email-value">{{ item.bcc[0] }}</span>
                    </template>
                    <template v-else>
                      <span class="email-value">&nbsp;</span>
                    </template>
                  </td>
                  <td>{{ item.responseStatus }}</td>
                  <td>{{ item.responseCode }}</td>
                  <td>
                    <sdx-expand-and-collapse v-if="item.backendError"
                                             expand-label="Show details"
                                             collapse-label="Hide details">
                      <div class="long-text">
                        <span>{{ item.backendError }}</span>
                      </div>
                    </sdx-expand-and-collapse>
                    <span v-else>&nbsp;</span>
                  </td>
                  <td v-if="item.attachments != null">
                    {{ item.attachments.numberOfAttachments }}
                  </td>
                  <td :title="'Last Update: ' + item.updatedOn">{{ item.createdOn }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div v-if="statisticOutbox.length === 0" class="no-items-found">
          <p><i>No outbox items found</i></p>
        </div>
        <div class="row justify-content-between">
          <div class="col-xs">
            <div v-if="totalPages != 1" class="email-outbox-pagination">
              <div v-bind:current-page="currentPage.number + 1" v-bind:total-pages="Math.ceil(totalElements / size)"
                   @pageChanged="search">
                <ul v-if="totalPages > 0" class="pagination">
                  <li class="pagination-item">
                    <sdx-button
                        id="onePageBackwards"
                        type="button"
                        label="<"
                        class="sdx-button"
                        @click="gotoPage( 1)"
                        :disabled="isFirstPage"/>
                  </li>
                  <li v-for="page in pages" v-bind:key="page" class="pagination-item">
                      <span
                          v-if="page.placeholder"
                          class="pagination-button inactive"
                      >
                        ...
                      </span>
                    <button
                        v-else
                        type="button"
                        class="pagination-button"
                        @click="gotoPage(page.pageNumber)"
                        :class="`${page.currentPage ? 'active' : 'inactive'}`"
                    >
                      {{ page.pageNumber }}
                    </button>
                  </li>
                  <li class="pagination-item">
                    <sdx-button
                        id="nextPage"
                        type="button"
                        label=">"
                        class="sdx-button"
                        @click="gotoPage(currentPage + 1)"
                        :disabled="isLastPage"/>
                  </li>
                  <li class="pagination-item">
                    <sdx-button
                        id="lastPage"
                        type="button"
                        label=">>"
                        class="sdx-button"
                        @click="gotoPage(totalPages)"
                        :disabled="isLastPage"/>
                  </li>
                  <li class="pagination-item total-elements">
                    Total: {{ this.totalElements }}
                  </li>
                </ul>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import emailOutboxService from '../service'
import loadingSpinnerService from '@/services/loading-spinner.service';
import DevAppDropDownComponent from "@/components/DevAppDropDownComponent";
import {logger} from "@/services/logger.service";
import envService from "@/services/env.service";
import {showAlert} from "@/services/notification.service";
import userService from "@/services/user.service";
import {addDate, formatDate} from "@/util/utility";
import dateService from "@/services/date.service";

const dateRangeContext = 'email';
export default {
  components: {
    DevAppDropDownComponent,
  },
  data: function () {
    return {
      webId: undefined,
      statisticOutbox: [],
      expandedBackendErrors: [],
      totalPages: -1,
      pageNumber: -1,
      currentPage: -1,
      totalElements: -1,
      size: -1,
      page: [],
      showOutbox: false,
      cc: [],
      responseStatus: [],
      backendError: [],
      responseCode: [],
      numberOfAttachments: [],
      bcc: [],
      to: [],
      dateRange: {
        fromDate: dateService.getInitialFromDate(formatDate(addDate(new Date(), -envService.getDays4SmsSearch(), "days").setHours(0, 0, 0, 0)), dateRangeContext),
        formattedFromDate: undefined,
        toDate: dateService.getInitialToDate(formatDate(new Date().setHours(23, 59, 59, 999)), dateRangeContext),
        formattedToDate: undefined
      },
      loadingData: false,
      lastLoad: '',
      isAdmin: false,
    }
  },
  computed: {
    pages: function () {
      let previousPage = this.currentPage > 1 ? (this.currentPage - 1) : 1
      let nextPage = this.currentPage < this.totalPages ? (this.currentPage + 1) : this.totalPages
      let extraPreviousPage = previousPage === 3 ? 2 : null
      let extraNextPage = nextPage === (this.totalPages - 2) ? (this.totalPages - 1) : null
      let placeholderBefore = previousPage > 3 ? 2 : null
      let placeholderAfter = nextPage < (this.totalPages - 2) ? (this.totalPages - 1) : null

      let pages = []

      for (let i = 1; i <= this.totalPages; i += 1) {
        if ([1, this.totalPages, this.currentPage, previousPage, nextPage, extraPreviousPage, extraNextPage, placeholderBefore, placeholderAfter].includes(i)) {
          pages.push({
            pageNumber: i,
            currentPage: this.currentPage === i,
            placeholder: [placeholderBefore, placeholderAfter].includes(i)
          })
        }
      }
      return pages
    },
    isFirstPage: function () {
      return this.currentPage === 1
    },
    isLastPage: function () {
      return this.currentPage === this.totalPages
    },
    statusList: function () {
      return [
        {value: '400', label: 'Bad Request'},
        {value: '400', label: 'Invalid Request'},
      ];
    },
    envService() {
      return envService
    }
  },
  mounted() {
    if (this.$route.query.tag) {
      this.tag = this.$route.query.tag;
      logger.debug("tag: " + this.$route.query.tag)
    }
    this.getAdmin();
    dateService.updateFromDate(this.dateRange);
    dateService.updateToDate(this.dateRange);
  },
  methods: {
    async getAdmin() {
      this.isAdmin = await userService.isAdmin();
    },
    devAppChanged: async function (webId) {
      loadingSpinnerService.show("outbox")
      this.webId = webId;
      await this.loadData(1);
      loadingSpinnerService.hide("outbox")
    },
    loadData: async function (page) {
      let thisLoad = "loadData(" + page + ") with webId: " + this.webId +
          ", To: " + this.to +
          ", CC: " + this.cc +
          ", BCC: " + this.bcc +
          ", Status: " + this.responseStatus +
          ", Response: " + this.responseCode +
          ", Backend Error: " + this.backendError +
          ", Attachments: " + this.numberOfAttachments +
          ", fromDate: " + this.dateRange.formattedFromDate +
          ", toDate: " + this.dateRange.formattedToDate;
      logger.debug(thisLoad);
      //already loaded?
      if (thisLoad === this.lastLoad) {
        logger.debug("loadData already running/runned with same parameters")
        return
      }
      this.lastLoad = thisLoad;
      //wait for loadingData to finish
      while (this.loadingData) {
        logger.debug("waiting for loadingData to finish")
        await new Promise(resolve => setTimeout(resolve, 100));
      }
      this.loadingData = true;
      loadingSpinnerService.show("outbox-content")
      if (this.webId === undefined || this.webId === null || this.webId === '') {
        this.showOutbox = false
      } else {
        this.showOutbox = true;
        try {
          let response = await emailOutboxService.getEmailOutbox(this.webId,
              this.to,
              this.cc,
              this.bcc,
              this.responseStatus[0],
              this.dateRange.formattedFromDate,
              this.dateRange.formattedToDate,
              page - 1,
              20,
              "createdOn,DESC");
          console.log("response.data.content" + response.data.content);
          this.statisticOutbox = response.data.content;
          //this.expandedBackendErrors = new Array(this.statisticOutbox.length).fill(false);
          this.totalPages = response.data.totalPages;
          this.pageNumber = response.data.pageNumber;
          this.currentPage = response.data.number + 1;
          this.totalElements = response.data.totalElements;
          this.size = response.data.size;
        } catch (error) {
          logger.debug("Error: " + error)
          showAlert(error.message)
          this.statisticOutbox = []
        }
      }
      setTimeout(() => {
        this.loadingData = false;
        loadingSpinnerService.hide("outbox-content");
      }, 1000)
    },
    gotoPage: function (page) {
      this.loadData(page);
      this.$emit('pageChanged', page);
    },
    initTimeOutForLoadingData: function () {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        this.loadData(1);
      }, this.delay);
    },
    recipientChange: function () {
      this.to = arguments[0].target.value;
      this.initTimeOutForLoadingData();
    },
    ccChange: function () {
      this.cc = arguments[0].target.value;
      this.initTimeOutForLoadingData();
    },
    bccChange: function () {
      this.bcc = arguments[0].target.value;
      this.initTimeOutForLoadingData();
    },
    statusChange: function () {
      console.log("statusChange: " + arguments[0].target.value);
      this.responseStatus = arguments[0].target.value;
      this.initTimeOutForLoadingData();
    },
    fromDateChange: async function () {
      await dateService.fromDateChange(arguments[0].target.value, this.dateRange, dateRangeContext);
      this.initTimeOutForLoadingData();
    },
    toDateChange: async function () {
      await dateService.toDateChange(arguments[0].target.value, this.dateRange, dateRangeContext);
      this.initTimeOutForLoadingData();
    }
  }
};
</script>

<style scoped>
.filter-item {
  padding-right: 10px;
  padding-left: 0;
  padding-top: 3px;
  min-width: 200px; /* Mindestbreite für kleinere Bildschirme */
}

.filter-item-title{
  padding-right: 5px;
  font-size: 15px;
}

.subscription-table.table tbody td {
  padding-top: 5px;
  padding-bottom: 3px;
}

.total-elements {
  padding: 11px 23px;
}

.pagination {
  list-style-type: none;
}

.pagination-item {
  display: inline-block;
}

.sdx-button {
  min-width: 48px !important;
  min-height: 51px !important;
  margin-left: 2px;
  margin-right: 2px;
}

.pagination-button {
  padding: 11px 23px;
  border-radius: 5px;
  margin-left: 2px;
  margin-right: 2px;
}

.pagination-button.active {
  background-color: rgb(8, 106, 219);
  color: rgb(255, 255, 255);
  border: 1px solid rgb(8, 106, 219);
}

.pagination-button.inactive {
  background-color: rgb(207, 213, 217);
  color: rgb(51, 51, 51);
  border: 1px solid rgb(207, 213, 217);;
}

.email-outbox-pagination {
  margin-bottom: 40px;
}

td {
  padding: 0px !important;
}

.long-text {
  white-space: pre-wrap;
  word-wrap: break-word;
  max-width: 100%;
  line-height: 1.5;
}

.email-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.email-list li {
  padding: 8px 12px;
  border-bottom: 1px solid #e0e0e0;
  font-size: 0.95rem;
  color: #333;
}

.email-list li:last-child {
  border-bottom: none;
}

.email-value {
  display: inline-block;
  padding: 8px 12px;
  font-size: 0.95rem;
  color: #333;
}


</style>